import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class OpsService {

  constructor(private http: HttpClient) { }

  language(text: string): Observable<any> {
    return this.http
    .post(
      `/api/v1/email_detail/language`,
      { text: text }
    );
  }

  translate(text: string, language: string): Observable<any> {
    return this.http
    .post(
      `/api/v1/email_detail/translate/${language}`,
      { text: text }
    );
  }

  dataAge(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ops/dataage`
      );
  }

  getAlertTimings(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ops/alerttiming`
      );
  }

  getRawEmailStatus(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ops/rawemailstatus`
      );
  }

  getCustomerEmailStatus(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ops/customeremailstatus`
      );
  }

  getEmailDetailStatus(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ops/emaildetailstatus`
      );
  }

  getBatchqStatus(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ops/batchqstatus`
      );
  }

  runHubpostSyncJob(): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/ops/runjob/hubspotsync`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/ops.service.ts